import DepartmentStaffEdit from './DepartmentStaffEdit';

export default DepartmentStaffEdit;
